import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { Store, select } from '@ngrx/store';

import { Observable, Subscription } from 'rxjs';

import * as fromReducers from '../../reducers';

import * as newsActions from '../../actions/news.actions';
import { Post } from '../../interfaces';

@Component({
  selector: 'edge-news-single',
  templateUrl: './news-single.component.html',
  styleUrls: ['./news-single.component.scss']
})
export class PageNewsSingleComponent implements OnInit {
  newsArticle$: Observable<Post | undefined> = new Observable<Post>();
  socialMediaLinks$: Observable<object> = new Observable<object>();

  socialMediaLinksSubscription: Subscription = new Subscription();

  socialMediaLinks!: object;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<fromReducers.State>
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.id) {
        const routeId: number = parseInt(params.id, 0);
        this.newsArticle$ = this.store.pipe(
          select(fromReducers.getNewsArticleById(routeId))
        );
      } else {
        this.router.navigateByUrl('/news');
      }
    });

    this.socialMediaLinks$ = this.store.pipe(
      select(fromReducers.getSocialMediaLinks)
    );
  }
}
